import React from 'react';
export default {
  approvalControl: 'disabled',
  groups: [
    {
      id: 'id-verification',
      title: 'ID Verification',
      description: '',
      comments: '',
      readonly: false,
      items: [
        {
          id: 'headshot',
          title: 'Headshot',
          information: 'Will accept photos with hats.',
          criteria:
            'Ensure the following:<ul><li>Face is visible and clear</li><li>Head is in frame</li></ul>',
          comments: '',
          commentsRequired: true,
          reasons: ['Face is not visible and clear', 'Head is not in frame'],
          status: null,
          readOnly: false,
          required: true,
          media: {
            type: 'image',
            url: '',
            start: 0,
            end: 10,
          },
        },
        {
          id: 'id',
          title: 'Proof of ID',
          information: '',
          criteria: '',
          comments: '',
          commentsRequired: true,
          status: null,
          readOnly: false,
          required: true,
          media: {
            type: 'image',
            url: '',
            start: 0,
            end: 10,
          },
        },
      ],
    },
    {
      id: 'permitted-items',
      title: 'Permitted Items',
      description: '',
      comments: '',
      readonly: false,
      items: [
        {
          id: 'notes',
          title: 'Notes',
          information: '',
          criteria: '',
          comments: '',
          commentsRequired: true,
          status: null,
          readOnly: false,
          media: {
            type: 'image',
            url: '',
            start: 0,
            end: 10,
          },
        },
        {
          id: 'book',
          title: 'Open Text Book',
          information: '',
          criteria: '',
          comments: '',
          commentsRequired: true,
          status: null,
          readOnly: false,
          media: {
            type: 'image',
            url: '',
            start: 0,
            end: 10,
          },
        },
        {
          id: 'calculator',
          title: 'Calculator',
          information: '',
          criteria: '',
          comments: '',
          commentsRequired: true,
          status: null,
          readOnly: false,
          media: {
            type: 'image',
            url: '',
            start: 0,
            end: 10,
          },
        },
        {
          id: 'earplugs',
          title: 'Earplugs',
          information: '',
          criteria: '',
          comments: '',
          commentsRequired: true,
          status: null,
          readOnly: false,
          media: {
            type: 'image',
            url: '',
            start: 0,
            end: 10,
          },
        },
        {
          id: 'dictionary',
          title: 'Dictionary',
          information: '',
          criteria: '',
          comments: '',
          commentsRequired: true,
          status: 'reject',
          readOnly: false,
          media: {
            type: 'image',
            url: '',
            start: 0,
            end: 10,
          },
        },
        {
          id: 'websites',
          title: 'Websites',
          information: '',
          criteria: '',
          comments: '',
          commentsRequired: true,
          status: 'accept',
          readOnly: false,
        },
        {
          id: 'blank-paper',
          title: 'Blank Paper',
          information: '',
          criteria: '',
          comments: '',
          commentsRequired: true,
          status: 'optout',
          readOnly: false,
          media: {
            type: 'image',
            url: '',
            start: 0,
            end: 10,
          },
        },
        {
          id: 'bathroom',
          title: 'Bathroom Break',
          information: '',
          criteria: '',
          comments: '',
          commentsRequired: true,
          status: 'accept',
          readOnly: false,
        },
        {
          id: 'other',
          title: 'Other Items',
          information: '',
          criteria: '',
          comments: '',
          commentsRequired: true,
          status: null,
          readOnly: false,
          media: {
            type: 'image',
            url: '',
            start: 0,
            end: 10,
          },
        },
      ],
    },
    {
      id: 'environment-scan',
      title: 'Environment Scan',
      description: '',
      comments: '',
      readonly: false,
      items: [
        {
          id: 'full-scan',
          title: 'Full Room',
          information: '',
          criteria:
            'Ensure the following:<ul><li>Room is clean</li><li>Room is free of clutter</li><li>The scan was 360 degrees can covered the floor and ceiling areas.</li></ul>',
          reasons: [
            'Room is not clean',
            'Room is not free of clutter',
            'The scan was not 360 degrees can covered the floor and ceiling areas.',
          ],
          comments: '',
          commentsRequired: true,
          status: null,
          readOnly: false,
          media: {
            type: 'image',
            url: '',
            start: 0,
            end: 10,
          },
        },
      ],
    },
  ],
};
